import LoanProductVehicleType from './loanProductVehicleType';

export default function LoanProductVehicleTypeMap() {
    return new Map<string, string>([
        ['CAR', LoanProductVehicleType.CAR],
        ['CAR_ZERO_EMISSION', LoanProductVehicleType.CAR_ZERO_EMISSION],
        ['CAR_NO_INSURANCE', LoanProductVehicleType.CAR_NO_INSURANCE],
        ['MC', LoanProductVehicleType.MC],
        ['ATV', LoanProductVehicleType.ATV],
        ['SNOWMOBILE', LoanProductVehicleType.SNOWMOBILE],
        ['CAMPING_CAR', LoanProductVehicleType.CAMPING_CAR],
        ['CARAVAN', LoanProductVehicleType.CARAVAN],
        ['BOAT', LoanProductVehicleType.BOAT],
    ]);
}
